import React from 'react'
import { Section } from '@/components/frontend/atoms/layout/Section'
import { Container } from '@/components/frontend/atoms/layout/Container'
import { ProcessTrack } from '@/components/frontend/atoms/layout/ProcessTrack'
import { Stack } from '@/components/shared/atoms/layout/Stack'
import { SectionIntro } from '@/components/frontend/molecules/SectionIntro'
import { StepItem } from '@/components/frontend/molecules/StepItem'
import { useTranslation } from '@/hooks/useTranslation'

const STEPS = ['call', 'proposal', 'build', 'support'] as const

export const WorkflowSection: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Section padding="lg" id="workflow">
      <Container>
        <Stack gap="12">
          <SectionIntro label={t('workflow.label')} title={t('workflow.heading')} subtitle={t('workflow.subheading')} />
          <ProcessTrack>
            {STEPS.map((key, index) => (
              <StepItem
                key={key}
                number={index + 1}
                meta={t(`workflow.${key}_meta`)}
                title={t(`workflow.${key}_title`)}
                description={t(`workflow.${key}_desc`)}
              />
            ))}
          </ProcessTrack>
        </Stack>
      </Container>
    </Section>
  )
}
